// extracted by mini-css-extract-plugin
export var filterIncDec = "_c3-0";
export var leftBorder = "_c3-1";
export var rightBorder = "_c3-2";
export var stringInput = "_c3-3";